import { PublicNav, PublicFooter } from "../../components/public/PublicNav";
import { useSeo } from "../../hooks/useSeo";

export const PublicLegal = () => {
  useSeo({
    title: "Mentions légales | Rouge Première",
    description: "Mentions légales du site Rouge Première : éditeur, hébergeur, propriété intellectuelle, protection des données.",
  });
  return (
  <div>
    <PublicNav />
    <main className="max-w-[900px] mx-auto px-5 md:px-10 py-16 md:py-24" data-testid="legal-page">
      <div className="text-[11px] uppercase tracking-[0.3em] text-[var(--red)]">Informations</div>
      <h1 className="font-display text-4xl md:text-5xl mt-3">Mentions légales</h1>

      <div className="mt-10 space-y-8 text-neutral-700 leading-relaxed">
        <Section title="Éditeur du site">
          <p>
            Le site <strong>Rouge Première</strong> (accessible à l'adresse{" "}
            <a href="https://rougepremiere.com" className="text-[var(--red)] underline">
              rougepremiere.com
            </a>
            ) est édité par Emmanuel Racca, éditeur indépendant.
          </p>
          <p className="text-sm text-neutral-600 mt-2" data-testid="legal-company-id">
            Entreprise individuelle — SIREN : 497 519 116 — SIRET : 497 519 116 00022.
          </p>
          <p className="text-sm text-neutral-600 mt-2">
            Contact : via le{" "}
            <a href="/contact" className="text-[var(--red)] underline">
              formulaire de contact
            </a>{" "}
            du site.
          </p>
        </Section>

        <Section title="Directeur de la publication">
          <p>
            Emmanuel Racca, en sa qualité d'éditeur du site.
          </p>
        </Section>

        <Section title="Hébergement">
          <p>
            Le site est hébergé par <strong>Emergent Labs Inc.</strong>
          </p>
          <ul className="text-sm text-neutral-700 mt-2 space-y-1">
            <li>
              Adresse : 2380 Via Espada, Pleasanton, CA 94566, États-Unis
            </li>
            <li>
              Immatriculation : Delaware File Number 2024 (US Registration)
            </li>
            <li>
              Contact :{" "}
              <a
                href="mailto:support@emergent.sh"
                className="text-[var(--red)] underline"
              >
                support@emergent.sh
              </a>
            </li>
          </ul>
          <p className="text-sm text-neutral-600 mt-3">
            Emergent Labs Inc. agit en qualité d'hébergeur au sens de l'article 6-I-2 de la
            loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique
            (LCEN).
          </p>
        </Section>

        <Section title="Propriété intellectuelle">
          <p>
            L'ensemble des contenus éditoriaux (textes, articles, sélections, photos, vidéos,
            interviews et la marque) est la propriété exclusive de Rouge Première, sauf mention contraire. Les affiches, photographies et
            métadonnées de films et séries proviennent de{" "}
            <a href="https://www.themoviedb.org/" target="_blank" rel="noreferrer" className="text-[var(--red)] underline">
              TMDB
            </a>{" "}
            et restent la propriété de leurs ayants droit respectifs.
          </p>
          <p className="mt-3 flex flex-wrap items-center gap-2" data-testid="legal-tmdb-notice">
            <img src="/tmdb-logo.svg" alt="TMDB" className="h-3 w-auto" />
            <span>Ce site utilise l'API TMDB mais n'est ni approuvé ni certifié par TMDB.</span>
          </p>
        </Section>

        <Section title="Données personnelles">
          <p>
            Rouge Première recueille les informations transmises via le formulaire de contact
            (nom, email, message) dans l'unique but de répondre aux demandes. Ces données ne sont
            ni revendues ni utilisées à des fins commerciales. Conformément au RGPD, vous pouvez
            demander à tout moment la suppression de vos données en nous contactant.
          </p>
          <p className="mt-3">
            Newsletter : votre adresse email est utilisée uniquement pour l'envoi de la
            newsletter hebdomadaire, après confirmation de votre part (double opt-in). Elle est
            transmise à notre prestataire d'envoi (Resend) et n'est jamais revendue. Chaque email
            contient un lien de désinscription en 1 clic ; votre adresse est alors retirée des envois.
          </p>
        </Section>

        <Section title="Cookies et mesure d'audience">
          <p>
            Le site utilise des cookies techniques strictement nécessaires à son
            fonctionnement (session, préférences d'affichage). Ces cookies ne
            requièrent pas de consentement.
          </p>
          <p className="mt-2">
            Rouge Première utilise également <strong>Google Analytics 4</strong>{" "}
            pour mesurer la fréquentation du site (nombre de visiteurs, pages
            consultées). Ce dispositif est configuré avec l'anonymisation IP et
            n'est activé qu'après votre consentement, via le bandeau affiché lors
            de votre première visite. Aucune donnée n'est utilisée à des fins
            publicitaires ni de reciblage. Vous pouvez retirer votre consentement
            à tout moment via le lien « Gérer les cookies » situé en bas de
            chaque page.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Pour toute question relative à ces mentions, utilisez notre{" "}
            <a href="/contact" className="text-[var(--red)] underline">formulaire de contact</a>.
          </p>
        </Section>
      </div>
    </main>
    <PublicFooter />
  </div>
  );
};

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-display text-2xl md:text-3xl mb-3">{title}</h2>
    <div className="text-sm md:text-base">{children}</div>
  </section>
);
